// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
import { IClientOptions } from 'mqtt';
import { AzureEnvironment, idNameItem } from 'jk-service';

export const companyList: idNameItem[] = [
  {
    id: 'JACK168-86',
    name: 'stock https://jk-stock.jack168.com:8086',
    icon: './assets/images/jack_logo.png',
    ps1: 'https://jk-stock.jack168.com:8086',
    ps2: 'JACKIE,KM_SYS,JACK',
    ps3: '',
  },
  {
    id: 'rd-u24',
    name: '傑克測試(rd-u24)',
    icon: './assets/images/jack_logo.png',
    ps1: 'http://rd-u24.local:9086',
    ps2: 'JACKIE,KM_SYS,JACK',
    ps3: '',
  },
  {
    id: 'LOCAL-86',
    name: 'stock http://localhost:9086',
    icon: '',
    ps1: 'http://localhost:9086',
    ps2: 'JACKIE,KM_SYS,JACK',
    ps3: '',
  },
  {
    id: 'u24-dt-86',
    name: 'stock u24-dt:9086',
    icon: './assets/images/jack_logo.png',
    ps1: 'http://u24-dt:9086',
    ps2: 'JACKIE,KM_SYS,JACK',
    ps3: '',
  }];



const jack168Mqtt: IClientOptions = {
  port: 6883,
  host: "jkw10-vm.jack168.com",
  protocol: "mqtts", // mqtt:1883
  clientId: "jkStock",
  path: "",
  username: "admin",
  password: "Camel168",
  //keepalive: 60,
};

export let jack168Ws: IClientOptions = {
  port: 6083,
  host: "jkw10-vm.jack168.com",
  protocol: "wss", // wss:8083 ws:8080
  clientId: "jkStock",
  path: "/mqtt",
  username: "admin",
  password: "Camel168",
  //keepalive: 60,
};
//ws://jack168.com:6083 mqtt://jack168.com:6082
const azureU24Mqtt: IClientOptions = {
  port: 1883,
  host: "azure-u24.jack168.com",
  protocol: "mqtt", // mqtt:1883
  clientId: "jkStock",
  username: "",
  password: "",
};

export const mqttOptions: any = {
  default: azureU24Mqtt,
  azureU24Mqtt: azureU24Mqtt,
  jack168Mqtt: jack168Mqtt,
  jack168Ws: jack168Ws,
};

export const environment = {
  production: false,
  appName: 'jkstock',
  title: '傑克股票系統',
  appDescript: '傑克股票APP',
  appId: 'jk-stock',
  version: '20260802-6',
  jwtSecret: 'giant168',
  sysdbname: 'KM_SYS',
  baseAttachUrl: 'http://rd-u24.local:9099',
  reportUrl: 'https://jack168.com/report',
  configFileName: 'jk-stock.json',

  openai_upload: '~/openai_upload',
  downloadData: [
    { sql: 'SELECT * FROM CMSMA', table: 'CMSMA', keyField: 'MA001' },
    { sql: 'SELECT * FROM CMSMC', table: 'CMSMC', keyField: 'MC001' },
    { sql: 'SELECT * FROM CMSME', table: 'CMSME', keyField: 'ME001' },
    { sql: 'SELECT * FROM CMSMV', table: 'CMSMV', keyField: 'MV001' },
    { sql: 'SELECT * FROM ##CMSMM WHERE MM001=\'Pub_Phrase\' ', table: 'CMSMM', keyField: 'MM001' },
    { sql: 'SELECT * FROM ##SYSUser ORDER BY UserID', table: 'SYSUser', keyField: 'UserID' },
    // 幣別
    {
      sql: ' select MF001,MF002,MF003,MF004,MF005,MF007,(SELECT TOP 1 MG002 FROM CMSMG WHERE MG001=MF001 ORDER BY MG002 DESC) AS MG002,' +
        ' (SELECT TOP 1 MG003 FROM CMSMG  WHERE MG001=MF001 ORDER BY MG002 DESC) AS MG003, ' +
        ' (SELECT TOP 1 MG004 FROM CMSMG WHERE MG001=MF001 ORDER BY MG002 DESC) AS MG004 ' +
        ' from CMSMF  ORDER BY MF001 ', table: 'CMSMF', keyField: 'MF001'
    }
  ],
  testUrl: 'https://jack168.com:8086',
  fbId: 'FACEBOOK_APP_ID',
  stripePublicKey: 'STRIPE_PUBLIC_KEY',
  expireHour: 36,
  androidHeaderColor: '#5D67D4',
  defaultLang: 'zh-TW',
  mqtt: {
    server: 'jk-ubun',
    protocol: 'ws',
    path: '',
    port: 8080
  },
  mqtt2: {
    hostname: 'jack168.com',
    port: 8080,
    path: '/mqtt'
  },
  GOOGLE_CLIENT_ID: '502092863161-u111mcnubjn7t16sr464b6mjblsjspeq.apps.googleusercontent.com',
  GOOGLE_API_KEY: '請由service提供', // jkchat
  currency: {
    code: 'NTD',
    display: 'symbol',
    digitsInfo: '1.2-2',
  },
  wsUrl: 'ws://jk-ubun:8888',
  emulator: false,
  serverIP: 'localhost',

};

export const azureEnv: AzureEnvironment = {
  tts_key: '',
  tts_url: 'https://eastasia.tts.speech.microsoft.com/cognitiveservices/v1',// 'https://eastasia.api.cognitive.microsoft.com/', // 'https://eastasia.tts.speech.microsoft.com/cognitiveservices/v1',
  translate_key: '',
  AZURE_OPENAI_KEY: '',
  AZURE_OPENAI_ENDPOINT: '',
  region: 'eastasia',
};

